import React from 'react'
import { Switch, Route, Redirect, useLocation } from 'react-router-dom'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

import { HomePage } from './pages'
import { ServicesPage } from './pages/services'
import { WashPage } from './pages/services/wash'
import { FAQsPage } from './pages/faqs'
// import { UserPage } from './pages/user'
import { SignInPage } from './pages/user/sign-in'
import { SignUpPage } from './pages/user/sign-up'
import { ResetPasswordPage } from './pages/user/reset-password'
import { RestorePasswordPage } from './pages/user/restore-password'
import { PromoCodePage } from './pages/user/promo-code'
import { BookingPage } from './pages/booking'
import { CheckoutSuccess } from './pages/booking/components/checkout-success'
import { CheckoutCancel } from './pages/booking/components/checkout-cancel'
// The two legal pages are a lazy chunk (lib/chunk.js, client/packs/legal.js).
import { ChunkPage } from './lib/chunk'
import { FeedbackPage } from './pages/feedback'
import { CorporatePage, OperatorsPage } from './pages/contact'

export const Routes = React.memo(() => {
  const location = useLocation()

  return (
    <TransitionGroup>
      <CSSTransition key={location.key} classNames="fade" timeout={300}>
        <Switch location={location}>
          <Route exact path="/services" component={ServicesPage} />
          {/* One page per wash, server-rendered; this route keeps the server's markup (pages/services/wash). */}
          <Route exact path="/services/:wash" component={WashPage} />
          {/* Pricing page killed - comparison table + booking flow now live on /services. Redirect preserves any external/SEO links pointing at /pricing. */}
          <Route exact path="/pricing" render={({ location }) => <Redirect to={{ pathname: '/services', search: location.search }} />} />
          <Route exact path="/faqs" component={FAQsPage} />
          <Route exact path="/terms_and_conditions" render={() => <ChunkPage chunk="legal" page="TermsAndConditionsPage" />} />
          <Route exact path="/privacy_policy" render={() => <ChunkPage chunk="legal" page="PrivacyPolicyPage" />} />
          {/* No session id = the payment-recovery return (Stripe hosted retry after a failed off-session charge); the webhook has already finalized. */}
          <Route exact path="/checkout/success/:sessionId?" component={CheckoutSuccess} />
          <Route exact path="/checkout/cancel" component={CheckoutCancel} />
          <Route path="/booking" component={BookingPage} />

          {/* <Route exact path="/user" component={UserPage} /> */}
          <Route exact path="/user/sign_in" component={SignInPage} />
          <Route exact path="/user/sign_up" component={SignUpPage} />
          <Route exact path="/user/reset_password" component={ResetPasswordPage} />
          <Route exact path="/user/restore_password" component={RestorePasswordPage} />
          <Route exact path="/user/promo_code" component={PromoCodePage} />
          <Route exact path="/corporate" component={CorporatePage} />
          <Route exact path="/operators" component={OperatorsPage} />
          <Route exact path="/feedback" component={FeedbackPage} />
          <Route exact path="/feedback/thank-you" component={FeedbackPage} />
          <Route component={HomePage} />
        </Switch>
      </CSSTransition>
    </TransitionGroup>
  )
})
